export const APP_TIMEZONE_OPTIONS = [
  { value: "EST", label: "EST" },
  { value: "CST", label: "CST" },
  { value: "MST", label: "MST" },
  { value: "PST", label: "PST" },
  { value: "AKST", label: "AKST" },
  { value: "HST", label: "HST" },
] as const;

export type AppTimezone = (typeof APP_TIMEZONE_OPTIONS)[number]["value"];

export const DEFAULT_APP_TIMEZONE: AppTimezone = APP_TIMEZONE_OPTIONS[0].value;

export function normalizeAppTimezone(value?: string | null): AppTimezone {
  const candidate = value?.trim();
  const exists = APP_TIMEZONE_OPTIONS.some((timezone) => timezone.value === candidate);
  return exists ? (candidate as AppTimezone) : DEFAULT_APP_TIMEZONE;
}